import { gql } from '@apollo/client';
import { Role, User, UserGoal } from 'types';

export const GET_ME_QUERY = gql`
  query GetMe($year: Int) {
    getMe(year: $year) {
      _id
      empId
      name
      annualUserInfo {
        _id
        period
        overallRatingBySelf
        overallRatingByManager
        overallRatingByAdmin
        hrRemarks
      }
      hod {
        _id
      }
      createdAt
      role {
        _id
        name
      }
      reportingManager {
        _id
      }
      reportees {
        _id
      }
    }
  }
`;

export type GetMeQueryResponse = {
  getMe: User;
};

export type GetMeQueryVariables = {
  year?: number;
};

export const GET_USERS_QUERY = gql`
  query GetUsers($filter: UserFilter) {
    getUsers(filter: $filter) {
      _id
      empId
      name
      email
      department
      designation
      annualUserInfo {
        _id
        period
        startYearStatus
        midYearStatus
        endYearStatus
      }
    }
  }
`;

export type GetUsersQueryResponse = {
  getUsers: User[];
};

export type GetUsersQueryVariables = {
  filter?: {
    hod?: string;
    department?: string;
    role?: string[];
    searchTerm?: string;
    year?: number;
  };
};

export const GET_USER_BY_ID_QUERY = gql`
  query GetUserById($user: ID!, $year: Int) {
    getUserById(user: $user, year: $year) {
      _id
      name
      annualUserInfo {
        _id
        period
        startYearStatus
        midYearStatus
        endYearStatus
        overallCommentByEmployee
        overallCommentByManager
        isRecommendedForPromotion
        overallRatingBySelf
        overallRatingByManager
        overallRatingByAdmin
        hrRemarks
      }
      reportingManager {
        _id
        name
      }
      promotionAnswers {
        _id
        desc
        qa {
          _id
          desc
        }
      }
      promotionQuestions {
        _id
        desc
        answer {
          _id
          desc
        }
      }
      reportees {
        _id
        name
        email
        designation
        empId
        annualUserInfo {
          startYearStatus
          midYearStatus
          endYearStatus
        }
      }
    }
  }
`;

export type GetUserByIdResponse = {
  getUserById: User;
};

export type GetUserByIdVariables = {
  user: string;
  year?: number;
};

export const GET_USER_GOALS = gql`
  query GetUserGoals($user: ID!, $year: Int!) {
    getUserGoals(user: $user, year: $year) {
      _id
      kpi
      kra
      target
      weightage
      empCommentMidYear
      managerCommentMidYear
      empCommentEndYear
      empRatingEndYear
      managerCommentEndYear
      managerRatingEndYear
      user {
        _id
        annualUserInfo {
          _id
          endYearStatus
          isRecommendedForPromotion
          midYearStatus
          overallCommentByEmployee
          overallCommentByManager
          startYearStatus
          year
        }
      }
    }
  }
`;

export type GetUserGoalsResponse = {
  getUserGoals: UserGoal[];
};

export type GetUserGoalsVariables = {
  user: string;
  year: number;
};

export const DOWNLOAD_EVALUATION_REPORTS = gql`
  query DownloadEvaluationReports($users: [ID!]!, $year: Int) {
    downloadEvaluationReports(users: $users, year: $year) {
      file
      fileName
    }
  }
`;

export type DownloadEvaluationReportsResponse = {
  downloadEvaluationReports: {
    file: string;
    fileName: string;
  };
};

export type DownloadEvaluationReportsVariables = {
  users: string[];
  year: number;
};

export const GET_REPORTEES_QUERY = gql`
  query GetReportees($userId: ID!, $year: Int) {
    getReportees(userId: $userId, year: $year) {
      _id
      empId
      name
      email
      designation
      department
      annualUserInfo {
        startYearStatus
        midYearStatus
        endYearStatus
      }
    }
  }
`;

export const GET_DEPARTMENTS_QUERY = gql`
  query Query($userId: ID) {
    getUserDepartment(userId: $userId)
  }
`;

export type GetUserDepartmentResponse = {
  getUserDepartment: string[];
};

export type GetUserDepartmentVariables = {
  userId?: string;
};

export const GET_DESIGNATIONS_QUERY = gql`
  query Query {
    getDesignations
  }
`;

export type GetUserDesignationsResponse = {
  getDesignations: string[];
};

export type GetUserDesignationsVariables = {};

export const GET_ROLES_QUERY = gql`
  query GetRoles {
    getRoles {
      _id
      name
    }
  }
`;

export type GetRolesResponse = {
  getRoles: Role[];
};

export const GET_HODs_QUERY = gql`
  query GetHODs {
    getHODs {
      _id
      name
    }
  }
`;
export type GetHODsResponse = {
  getHODs: User[];
};

export type GetReporteesVariables = {
  userId: string;
  year?: number;
};

export type GetReporteesResponse = {
  getReportees: User[];
};

export const GET_USERS_FOR_AC = gql`
  query GetUsers($filter: UserFilter) {
    getUsers(filter: $filter) {
      _id
      empId
      name
    }
  }
`;

export const GET_BANDS_QUERY = gql`
  query Query($designation: String!) {
    getBands(designation: $designation)
  }
`;

export type GetBandsQueryVariables = {
  designation: string;
};

export type GetBandsQueryResponse = {
  getBands: string[];
};

export const GET_LEVELS_QUERY = gql`
  query Query($band: String!, $designation: String!) {
    getLevels(band: $band, designation: $designation)
  }
`;

export type GetLevelsQueryResponse = {
  getLevels: number[];
};

export type GetLevelsQueryVariables = {
  band: string;
  designation: string;
};

export const GET_FREEZED_USERS = gql`
  query Query($year: Int!, $period: Int!) {
    getFreezedUsers(year: $year, period: $period)
  }
`;

export type GetFreezedUsersVariables = {
  year: number;
  period: number;
};

export type GetFreezedUsersResponse = {
  getFreezedUsers: Boolean;
};
